// pwa/src/components/Orders.js
import React, { useContext, useEffect, useState, useRef } from "react";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import { DataGrid, GridActionsCellItem, GridRowId } from "@mui/x-data-grid";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import OrderModalContent from "./OrderModalContent";
import Grid from "@mui/material/Grid";
// import DOMPurify from 'dompurify';
import { Button, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";

const Orders = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [orders, setOrders] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const OrderModalContentRef = useRef();
  // Nuevo estado para el ID del producto que se está editando
  const [productToEditId, setProductToEditId] = useState(null);

  const handleOpenOrderModalContent = () => {
    setProductToEditId(null); // Asegurarse de que no haya ID de producto para edición
    OrderModalContentRef.current?.handleClickOpen();
  };

  const getOrders = () => {
    const { page, pageSize } = paginationModel;

    let sortParams = "";
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      sortParams = `&sortField=${field}&sortOrder=${sort}`;
    }

    axios
      .get("/api/orders?page=" + page + "&pageSize=" + pageSize + sortParams)
      .then((response) => {
        setOrders(response.data.orders);
        setTotalRows(response.data.total);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEditClick = (id) => {
    setProductToEditId(id); // Establecer el ID del producto a editar
    OrderModalContentRef.current?.handleClickOpen();
    console.log("Edit clicked for row:", id);
  };

  const handleDeleteClick = (id) => {
    console.log("Delete clicked for row:", id);
  };

  const createContent = () => {
    // Lógica para crear contenido
    console.log("Crear contenido");
  };

  useEffect(() => {
    getOrders();
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({ id: "app.header.orders.label" }),
        },
      ]);
    }
  }, [paginationModel, sortModel]); // Se ejecuta cuando cambia la paginación o la ordenación

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    {
      field: "locationName",
      headerName: "Name",
      width: 100,
      valueGetter: (value, row) => row.location?.name || "",
    },
    {
      field: "orderStatus",
      headerName: "Status",
      width: 100,
      valueGetter: (value, row) => row.order_status?.name || "",
    },
    { field: "orderNumber", headerName: "Order Number", width: 200 },
    {
      field: "products",
      headerName: "Productos",
      flex: 1,
      valueGetter: (value, row) => {
        const products = row?.products || []; // seguro aunque params.row sea undefined
        return products
          .map((p) => `${p.order_products?.quantity || 0} x ${p.name}`)
          .join(", ");
      },
    },
    { field: "createdAt", headerName: "Fecha y Hora", width: 200 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "center" }}>
            <Box sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={orders}
                columns={columns}
                pagination
                paginationMode="server"
                sortingMode="server"
                rowCount={+totalRows}
                pageSizeOptions={[5, 10, 25, 50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                sortModel={sortModel}
                onSortModelChange={(model) => setSortModel(model)}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={1}></Grid>
        </Grid>
        {/* PASAR EL ID DEL PRODUCTO A EDITAR AL MODAL, shopId sigue siendo 1 */}
        <OrderModalContent
          shopId={context?.shop?.id}
          orderId={productToEditId}
          onSaveSuccess={getOrders}
          ref={OrderModalContentRef}
        />
      </Container>
    </Layout>
  );
};

export default Orders;
